export default "__VITE_ASSET__8f1fc03a__"